import React from "react";
import SectionHeader from "../../../molecules/SectionHeader";

type ReceiptsHeaderProps = {
  total?: number;
  viewOption: any[];
  updateValue: any;
  handleView: (property: any, label: string) => void;
  setDateTo: (v: any) => void;
  dateTo: any;
  setDateFrom: (v: any) => void;
  dateFrom: any;
  setDrawer: (v: boolean) => void;
  downloadAction: () => void;
  actionButtons?: React.ReactNode;
};

const ReceiptsHeader: React.FC<ReceiptsHeaderProps> = (props) => {
  const {
    total,
    viewOption,
    updateValue,
    handleView,
    setDateTo,
    dateTo,
    setDateFrom,
    dateFrom,
    setDrawer,
    downloadAction,
    actionButtons,
  } = props;

  return (
    <SectionHeader
      heading="Receipts"
      total={total}
      viewOption={viewOption}
      justifyStart={true}
      updateValue={updateValue}
      handleView={handleView}
      noBorder={true}
      downloadAction={downloadAction}
      setDateTo={setDateTo}
      dateTo={dateTo}
      setDateFrom={setDateFrom}
      dateFrom={dateFrom}
      setDrawer={setDrawer}
      currentScreen={"receipts"}
      additionalFilters={true}
      actionButtons={actionButtons}
    />
  );
};

export default ReceiptsHeader;
